import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { SpinningLoader } from "@/components/SpinningLoader";
import { PATHS } from "@/constants/paths";
import { useAdminAuth } from "@/hooks/use-admin-auth";

interface IAdminNonProtectedRouteProps {
  children: ReactNode;
}

export const AdminNonProtectedRoute = ({
  children,
}: IAdminNonProtectedRouteProps): ReactNode => {
  const { admin, isLoading } = useAdminAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <SpinningLoader />
      </div>
    );
  }

  if (admin) {
    return <Navigate to={PATHS.ADMIN.DASHBOARD} replace />;
  }

  return <>{children}</>;
};
